import { useAllLocationsSelectedDealerId } from "components/DealersAndLocationsDropdown/hooks";
import { usePermanentLocations } from "components/DealersAndLocationsDropdown/hooks/usePermanentLocations";
import { usePermanentRealtimeDealers } from "components/DealersAndLocationsDropdown/hooks/usePermanentRealTimeDealers";
import { usePermanentRealTimeUser } from "hooks";

export const useAllSelectedLocationIds = () => {
  const { user } = usePermanentRealTimeUser();
  const { dealers } = usePermanentRealtimeDealers();
  const { locations } = usePermanentLocations();
  const { allLocationsSelectedDealerId } = useAllLocationsSelectedDealerId();

  if (user?.my_locations?.length) {
    const dealerLocations = locations.filter(loc => loc.dealer_id === allLocationsSelectedDealerId);
    return dealerLocations.filter(loc => user.my_locations?.includes(loc.id)).map(loc => loc.id);
  }
  if (user?.location_ids?.length) {
    const dealerLocations = locations.filter(loc => loc.dealer_id === allLocationsSelectedDealerId);
    return dealerLocations.filter(loc => user.location_ids?.includes(loc.id)).map(loc => loc.id);
  }

  const selectedDealer = dealers.find(d => d.id === user?.dealer_id);
  return selectedDealer?.locations?.filter(loc => loc.active).map(loc => loc.id) || [];
};
